module.exports = __webpack_public_path__ + "img/trash.47254f17.svg";